//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  angular.module('curalate').service('ListeningInboxBrandService', [
    '$http',
    'PromiseService',
    function(
            $http,
            PromiseService,
        ) {
      const BASE_URL = '/api/listening';
      const POSTS_URL = `${BASE_URL}/brand-posts`;
      const COMMENTS_URL = `${BASE_URL}/brand-comments`;

            // ***************
            //    POSTS_URL
            // ***************
      this.getBrandPost = function(postId, network) {
        const params = {
          network,
        };

        return PromiseService.processHttpResponse($http.get(`${POSTS_URL}/${postId}`, { params }));
      };

      this.getBrandPosts = function(params) {
        return PromiseService.processHttpResponse($http.get(POSTS_URL, { params }));
      };

            // Uses POSTS_URL as it needs a post id
      this.postBrandComment = function(postId, comment, network, userId, targetComment) {
        const params = {
          network,
          userId,
          targetComment,
        };
        const data = {
          comment,
        };

        return PromiseService.processHttpResponse($http.post(`${POSTS_URL}/${postId}/comments`, data, { params }));
      };

            // Uses POSTS_URL as it needs a post id
      this.deleteBrandComment = function(userId, postId, commentId, network) {
        const params = {
          network,
          userId,
        };
        return PromiseService.processHttpResponse($http.delete(`${POSTS_URL}/${postId}/comments/${commentId}`, { params }));
      };

            // ******************
            //    COMMENTS_URL
            // ******************
      this.getBrandComments = function(params) {
        return PromiseService.processHttpResponse($http.get(COMMENTS_URL, { params }));
      };
    },
  ]);
})();
